/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_TitleInputs */

const en_link_editor_title = /** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Links`)
};

const es_link_editor_title = /** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlaces Externos`)
};

const fr_link_editor_title = /** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liens externes`)
};

const de_link_editor_title = /** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe Links`)
};

/** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */
const ja_link_editor_title = en_link_editor_title;

/** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */
const zh_link_editor_title = en_link_editor_title;

/** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */
const ar_link_editor_title = en_link_editor_title;

/** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */
const id_link_editor_title = en_link_editor_title;

/** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */
const it_link_editor_title = en_link_editor_title;

/** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */
const ru_link_editor_title = en_link_editor_title;

/** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */
const pt_link_editor_title = en_link_editor_title;

/** @type {(inputs: Link_Editor_TitleInputs) => LocalizedString} */
const ko_link_editor_title = en_link_editor_title;

/**
* | output |
* | --- |
* | "External Links" |
*
* @param {Link_Editor_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_title = /** @type {((inputs?: Link_Editor_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_title(inputs)
	if (locale === "es") return es_link_editor_title(inputs)
	if (locale === "fr") return fr_link_editor_title(inputs)
	if (locale === "de") return de_link_editor_title(inputs)
	if (locale === "ja") return ja_link_editor_title(inputs)
	if (locale === "zh") return zh_link_editor_title(inputs)
	if (locale === "ar") return ar_link_editor_title(inputs)
	if (locale === "id") return id_link_editor_title(inputs)
	if (locale === "it") return it_link_editor_title(inputs)
	if (locale === "ru") return ru_link_editor_title(inputs)
	if (locale === "pt") return pt_link_editor_title(inputs)
	return ko_link_editor_title(inputs)
});